import React from 'react';
import axios from 'axios';
import { Form, Header, Segment, Loader } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl'; import { PieChart, Pie, Tooltip, Cell, Legend } from 'recharts';
import { fetchFaculties, fetchAcademicYears, fetchStudyCycle } from '../Lookups/util';
import { legendStyle, customLabel, DEFAULT_CHART_COLORS as colors, center } from './util';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class GraduatedStudentsPerFaculty extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            faculties: [],
            faculty: '',
            academicYears: [],
            academicYear: '',
            studyCycle: '',
            studyCycles: [],
            data: [],

            loading: true,
            showChart: false
        };

        this.fetchFacultiesAcademicYearsAndStudyCycle = this.fetchFacultiesAcademicYearsAndStudyCycle.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.generateRequests = this.generateRequests.bind(this);
        this.generateChartData = this.generateChartData.bind(this);
        this.getFacultyName = this.getFacultyName.bind(this);
        this.getStudyCycleName = this.getStudyCycleName.bind(this);
        this.getAcademicYearName = this.getAcademicYearName.bind(this);
    }

    componentDidMount() {
        this.fetchFacultiesAcademicYearsAndStudyCycle();
    }

    getAcademicYearName() {
        const { academicYear, academicYears } = this.state;
        const selected = academicYears.find(el => el.id === academicYear);
        if (selected && selected.name) return selected.name;
        return '';
    }
    getFacultyName(id) {
        const { faculties } = this.state;
        const selected = faculties.find(el => el.id === id);
        if (selected && selected.name) return selected.name;
        return '';
    }

    getStudyCycleName() {
        const { studyCycle, studyCycles } = this.state;
        const selected = studyCycles.find(el => el.id === studyCycle);
        if (selected && selected.displayName) return selected.displayName;
        return 'neki ciklus';
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    fetchFacultiesAcademicYearsAndStudyCycle() {
        axios.all([fetchFaculties(), fetchAcademicYears(), fetchStudyCycle()])
            .then(axios.spread((facultiesRes, academicYearsRes, studyCyclesRes) => {
                const faculties = facultiesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const academicYears = academicYearsRes.data.reverse().map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const studyCycles = studyCyclesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({
                    academicYears, faculties, studyCycles, loading: false
                });
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch faculties or academic years or study cycle');
            });
    }

    generateRequests() {
        const {
            faculty, academicYear
        } = this.state;
        return faculty.map(fId =>
            axios.get(`/statistics/graduated-per-study-cycle?facultyId=${fId}&academicYearId=${academicYear}`));
    }

    generateChartData() {
        const { faculty, studyCycle } = this.state;
        const calls = this.generateRequests();
        axios.all(calls)
            .then(allRes => {
                const dataArray = allRes.map(r => r.data);
                let data = dataArray.map(e => e.find(el => el.studyCycleId === studyCycle));
                data = data.map((el, i) => ({ ...el, name: this.getFacultyName(faculty[i]), value: el.numberOfStudents }));
                this.setState({ data, showChart: true });
            })
            .catch(err => {
                this.setState({ error: true, });
                console.log('Failed to fetch results');
            });
    }


    render() {
        const { data } = this.state;
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;

        return (
            <div>
                <Header as="h1">{<FormattedMessage id="statistics.statistic" />}</Header>
                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3">
                            {<FormattedMessage id="statistics.selectFacultyAcademicYearAndStudyCycle" />}
                        </Header>
                    </Segment><Segment>
                        <Form>
                            <Form.Group>
                                <Form.Dropdown
                                    label={<FormattedMessage id="common.faculty" />}
                                    placeholder={<FormattedMessage id="statistics.selectFaculty" />}
                                    value={this.state.faculty}
                                    onChange={this.handleInputChange}
                                    name="faculty"
                                    options={this.state.faculties}
                                    width={6}
                                    search
                                    multiple
                                    fluid
                                    selection
                                />

                                <Form.Dropdown
                                    label={<FormattedMessage id="common.academicYear" />}
                                    placeholder={<FormattedMessage id="statistics.selectAcademicYear" />}
                                    value={this.state.academicYear}
                                    onChange={this.handleInputChange}
                                    name="academicYear"
                                    options={this.state.academicYears}
                                    width={4}
                                    search
                                    fluid
                                    selection
                                />
                                <Form.Dropdown
                                    label={<FormattedMessage id="common.studyCycle" />}
                                    placeholder={<FormattedMessage id="statistics.selectStudyCycle" />}
                                    value={this.state.studyCycle}
                                    onChange={this.handleInputChange}
                                    name="studyCycle"
                                    options={this.state.studyCycles}
                                    width={3}
                                    search
                                    fluid
                                    selection
                                />

                                <Form.Button label=" " color="blue" basic="true" onClick={this.generateChartData}>{<FormattedMessage id="common.show" />}</Form.Button>
                            </Form.Group>
                        </Form>
                    </Segment>
                </Segment.Group>

                {this.state.showChart && <Segment.Group raised>
                    <Segment raised >
                        <Header as="h2">
                            {this.getFacultyName()}
                        </Header>
                        <Header as="h3">  {<FormattedMessage id="statistics.headerNumberGraduatedStudents" />}  {this.getStudyCycleName()} {this.getAcademicYearName()}   {<FormattedMessage id="statistics.headerAcademicYear" />} </Header>

                    </Segment>
                    {data.length ? <Segment>
                        <br />
                        <PieChart style={center} width={890} height={400}>
                            <Pie
                                isAnimationActive
                                label={customLabel}
                                data={data}
                                cx={300}
                                cy={160}
                                outerRadius={120}
                                innerRadius={30}
                            >
                                {
                                    data.map((entry, index) => <Cell fill={colors[index % colors.length]} />)
                                }
                            </Pie>
                            <Legend iconType="circle" iconSize={15} width={160} height={140} layout="vertical" align="left" verticalAlign="bottom" wrapperStyle={legendStyle} />
                            <Tooltip />
                        </PieChart>
                        <br />
                    </Segment>
                        : <Segment>
        Nema podataka na ovom fakultetu za odabranu akademsku godinu.
                        </Segment>}
                </Segment.Group>}
            </div>
        );
    }
}

export default GraduatedStudentsPerFaculty;



// WEBPACK FOOTER //
// ./src/views/Statistics/GraduatedStudentsPerFaculty.js